import apiClient from './apiClient';

export const authApi = {
  login: async (email, password) => {
    const response = await apiClient.post('/auth/login', { email, password }, {
      suppressGlobalErrorToast: true
    });
    return response.data;
  },

  register: async (email, password, fullName = null) => {
    const response = await apiClient.post('/auth/register', {
      email,
      password,
      ...(fullName && { full_name: fullName })
    }, {
      suppressGlobalErrorToast: true
    });
    return response.data;
  },

  getMe: async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },

  updateMe: async (data) => {
    const response = await apiClient.patch('/auth/me', data);
    return response.data;
  }
};
